import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: {},
    lifeTitle: localStorage.getItem('lifeTitle') ? localStorage.getItem('lifeTitle'): ''
  },
  mutations: {
    updateUserInfo(state, data) {
      state.user = data;
    },
    setLifeTitle(state, title) {
      state.lifeTitle = title
      localStorage.setItem('lifeTitle', title)
    }
  },
  actions: {},
  modules: {}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js